export class PromiseCache {

    cache: { [key: string]: ng.IPromise<any> };

    constructor() {
        this.cache = {};
    }

    get<T>(key, method: () => ng.IPromise<T>) {
        if (this.cache[key] != null) {
            return <ng.IPromise<T>>this.cache[key];
        } else {
            var promise = method();
            this.cache[key] = promise;
            return promise;
        }
    }

}